<template>

  <div>

    <master-data-form ref="CreateForm" mode="create" :on-update="reload"/>
    <master-data-form ref="UpdateForm" mode="update" :on-update="reload"/>

    <master-data-select-form ref="MasterDataSelectForm" mode="load" :on-update="reload"/>
    <master-data-select-form ref="LeaseChassisCreationForm" mode="createleasechassis" :on-update="reload"/>
    <md-card>
      <md-card-content>
        <div class="md-layout md-gutter">
          <div class="md-layout-item md-size-5">

          </div>
        <div>
          <span>
            <md-field :class="getValidationClass('DataForm.tagId')">
            <label id="label_tagId">Lease Chassis Id</label>
            <md-input id="tagId" ref="tagId" v-model="DataForm.tagId"/>
            </md-field>
          </span>

     
    
        </div>
        <div class="search" style="margin-left:10px;">
          <span>
            <md-field :class="getValidationClass('DataForm.tagName')">
            <label id="label_tagName">Sales Office</label>
            <md-input id="tagName" ref="tagName" v-model="DataForm.tagName"/>
            </md-field>
          </span>
        </div>
    
    <div class="md-layout-item md-size-25">
            <md-checkbox v-model="showOnlyActive">
              <label>Show Only Active Items</label>
            </md-checkbox>
          </div>

        <div>
           <md-button class="md-raised optionExtender" @click="doNew" :disabled="getPermission.stcAuditOnly.view">New</md-button>
        </div>
          
        <div class="search2" style="margin-left:100px;">
           <md-button class="btn-search-schedule md-primary md-raised optionExtender" @click="doSearch">Search</md-button>
        </div>
        <div>
           <md-button class="md-raised optionExtender" @click="doClear">Clear</md-button>
        </div>
        
          
         
          <div style="margin-left:1450px; margin-top: -200px;">
          </div>  
        </div>
      </md-card-content>
    </md-card>
    


    <br/>

    <calling-api path="/api/w/masterData">

      <pagination :items="getSortedMasterDatas">
        <template slot-scope="{pageItems}">
          <md-card class="data-table-container">
            <div class="outer-container">
             <div class="inner-container">
                <div class="table-header">
                  <table id="headertable">
                    <thead>
                    <tr>
                      <th class="header-cell w2"></th>
                      <th class="header-cell w8">Lease Chassis Id</th>
                      <th class="header-cell w10">Sales Office</th>
                      <th class="header-cell w3">Equip Size</th>
                      <th class="header-cell w5">Vendor</th>
                      <th class="header-cell w3">Active</th>
                      <th class="header-cell w7">Group</th>
                      <th class="header-cell w5">Create Person</th>
                      <th class="header-cell w5">Create Date</th>
                      <th class="header-cell w5">Create Time</th>
                      <th class="header-cell w5">Change Person</th>
                      <th class="header-cell w5">Change Date</th>
                      <th class="header-cell w5">Change Time</th>
                    </tr>
                    </thead>
                  </table>
                </div>
                <div class="table-body " @scroll="handleScroll">
                  <table id="bodytable">
                    <tbody>
                    <tr :key="item.tagId" v-for="item in pageItems">
                      <td class="body-cell w2">
                        <md-button @click="toggleUpdate(item)" class="md-icon-button">
                          <md-icon>mode_edit</md-icon>
                        </md-button>
                      </td>
                      <td class="body-cell w8">{{item.tagId}}</td>
                      <td class="body-cell w10">{{item.tagName}}</td>
                      <td class="body-cell w3">{{item.equipsize}}</td>
                      <td class="body-cell w5">{{item.vendor}}</td>
                      <td class="body-cell w3">{{item.active}}</td>
                      <td class="body-cell w7">{{item.group}}</td>
                      <td class="body-cell w5">{{item.createdBy}}</td>
                      <td class="body-cell w5">{{item.createdAt | date}}</td>
                      <td class="body-cell w5">{{item.createdAt | time}}</td>
                      <td class="body-cell w5">{{item.updatedBy}}</td>
                      <td class="body-cell w5">{{item.updatedAt | date}}</td>
                      <td class="body-cell w5">{{item.updatedAt | time}}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </md-card>

        </template>
      </pagination>
    </calling-api>
  </div>

</template>
<style scoped>
  .material-icons {
    font-family: 'Material Icons';
    font-weight: normal;
    font-size: 23px;
    display: inline-block;
    background-color: lightgray;
    margin-left: 300px;
    margin-top: 15px;
    -moz-osx-font-smoothing: grayscale;
  };
  #divider {
    height: 50px;
    width: 5px;
    background-color: black;
    display: inline-block;
  };
  .optionExtender {
    margin-left: 300px;
  };
  .optionExtender:hover{opacity:0.5};
  .searchTagName {
    margin-top: -15px;
    margin-left: 50px;
    display: inline-block;
  };
  .search {
    margin-left:10px;
  };
  .search2 {
    margin-left:100px;
  };
</style>
<script>
  import MasterDataForm from '../components/MasterDataForm.vue';

  import MasterDataSelectForm from '../components/MasterDataSelectForm.vue';
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialDataForm = () => ({
    group: "GST_LEASECHASSIS",
    tagId: null,
    tagName: null,
 
  });

  const getInitSearchRequest = () => ({
    group: "GST_LEASECHASSIS",
    tagId: null,
    tagName: null,
  });

  export default {
    data: () => ({
      selectedGroup: "GST_LEASECHASSIS",
   
      showOnlyActive: true,
      isload: false,
      isApp: false,
      isYG: false,
      isGeneral: false,
      isLocation: false,
      isCarrier: false,
      isCustomer: true,
      isRoute: false,
      isVendor: false,
      isLease: false,
      isRateBill: false,
      isRateCost: false,
      masterDatas: [],
      DataForm: getInitialDataForm(),
      searchRequest: getInitSearchRequest(),
      tagId: '',
    }),
    components: {
      MasterDataForm,

      MasterDataSelectForm,
    },
    computed: {
      ...mapGetters([
         'getPermission',
      ]),
      filteredMasterDatasByActive() {
        if (this.showOnlyActive) {
          return _(this.masterDatas)
            .filter(it => it.active);
        }
        return this.masterDatas;
      },
      getAllMasterGroups() {
        console.log("getAllMasterGroups");
        return _(this.filteredMasterDatasByActive || [])
          .chain()
          .pluck('group')
          .uniq()
          .sortBy(it => it)
          .value();
      },
      getFilteredMasterDatas() {
        //this.isload = false;
        console.log(JSON.stringify(this.searchRequest));
        if (!this.DataForm.tagId)
           this.DataForm.tagId = '';
        if (!this.DataForm.tagName)
           this.DataForm.tagName = '';

        console.log("getFilteredMasterDatas tagId: " + this.DataForm.tagId);
        console.log("getFilteredMasterDatas tagName: " + this.DataForm.tagName);
     



  
        console.log("getFilteredMasterDatas isLoad: " + this.isload);
        if (this.isload)
        {
           console.log("tagId: " + this.DataForm.tagId.toString());
           console.log("tagName: " + this.DataForm.tagName.trim());
           return  _(this.filteredMasterDatasByActive)
            .filter(it => (((this.selectedGroup) && (it.group === this.selectedGroup)) || ((!this.selectedGroup) && (it.group !== null)))
                  && (((this.DataForm.tagId !== '') && (it.tagId.includes(this.DataForm.tagId))) || ((this.DataForm.tagId === '') && (it.tagId !== null)))
                  && (((this.DataForm.tagName !== '') && (it.tagName.trim().includes(this.DataForm.tagName.trim()))) || ((this.DataForm.tagName === ''))   )
            )
                     
        }
        else
        {
          console.log("isLoad is false: " + this.isload);
          if (this.selectedGroup)
           return _(this.filteredMasterDatasByActive)
               .filter(it => it.group === this.selectedGroup);
          else
           return _(this.filteredMasterDatasByActive);
        }

      },
      getSortedMasterDatas() {
          return _(this.getFilteredMasterDatas)
            .sortBy(it => it.group);
      },
    },
    watch: {

      selectedGroup() {
        //if (this.isload) {
        switch(this.selectedGroup) {
          case "GST_LEASECHASSIS":
             this.$nextTick(() => {
               this.isApp = false; 
               this.isYG = false;
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = true;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false
             });
             break;

          default:
             this.$nextTick(() => {
               this.isApp = false; 
               this.isYG = false;
               this.isGeneral = false; 
               this.isLocation = false;
               this.isCarrier = false;
               this.isCustomer = true;
               this.isRoute = false;
               this.isVendor = false;
               this.isLease = false;
               this.isRateBill = false,
               this.isRateCost = false
             });
        }
        //}
        //this.isload = false;
      },
      masterDatas() {
        this.$nextTick(() => {
          this.updateTableHeight();
        });
      },
    },
    async mounted() {
      await this.reload();
    },
    methods: {

      async reload() {
        //const masterDatas = await api.post('/api/w/masterData',
        const masterDatas = await newAPIPost('/api/w/masterData',
        {groups:[
          "GST_LEASECHASSIS"

          ]});
        this.masterDatas = masterDatas;
      },
      handleScroll(e) {
        $(this.$el.querySelector('.table-header'))
          .offset({
            left: -1 * (e.target.scrollLeft - $('.outer-container')
              .offset().left),
          });
      },
      toggleCreate() {
        this.$refs.MasterDataSelectForm.openDialog();
      },
      toggleUpdate(item) {
        this.$refs.UpdateForm.openDialog(item);
      },
      doSearch() {
        console.log("reload datagrid");
        console.log(this.DataForm.tagId);
        this.$nextTick(() =>
        this.isload = true);
        //this.isload = true
        
      },
      doClear() {
        this.isload = false;
        console.log("tagId: " + document.getElementById("tagId").innerHTML);
        console.log("tagId value: " + document.getElementById("tagId").value);
        console.log("tagName value: " + document.getElementById("tagName").value);
        console.log("doClear isload: " + this.isload);
        this.selectedGroup = "GST_LEASECHASSIS";
        this.DataForm.group = "GST_LEASECHASSIS";
        this.DataForm.tagId = '';
        this.DataForm.tagName = '';

        this.DataForm = getInitialDataForm();         
        this.searchRequest = getInitSearchRequest();
         _(this.$el.querySelectorAll('button.md-input-action.md-clear')).each((it) => {
           it.click();
         });

        console.log(this.DataForm);
      },
      doNew() {
        this.$refs.LeaseChassisCreationForm.openDialog();
      },
      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },
      
    },
  };


</script>
